import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "outer" }
const _hoisted_2 = { class: "filters d-flex flex-row justify-content-between" }
const _hoisted_3 = { class: "filters__header d-flex flex-column flex-md-row align-items-md-end" }
const _hoisted_4 = { class: "filters__region-heading" }
const _hoisted_5 = { class: "filters__callsigns" }
const _hoisted_6 = { class: "filters__button-container" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Filter by ")
const _hoisted_8 = { class: "filters__menu__section-title" }
const _hoisted_9 = { class: "filters__menu__buttons d-flex flex-row d-md-none" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_SmartStatusFilter = _resolveComponent("SmartStatusFilter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.applianceStore.getRegionFilterName), 1),
        _createElementVNode("p", _hoisted_5, " (" + _toDisplayString(_ctx.applianceStore.getAreaFilteredCount) + " Callsigns) ", 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: _normalizeClass(["filters__button", { open: _ctx.isOpen }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleOpen()))
        }, [
          _hoisted_7,
          _createVNode(_component_font_awesome_icon, {
            icon: _ctx.isOpen ? 'times' : 'sliders-h',
            class: "filters__icon"
          }, null, 8, ["icon"])
        ], 2)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["filters__menu d-flex flex-column", { open: _ctx.isOpen }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterCategories, (section) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "filters__menu__section d-flex flex-column flex-md-row align-items-md-center",
          key: `${section.categoryTitle}-key`
        }, [
          _createElementVNode("p", _hoisted_8, _toDisplayString(section.categoryTitle) + ":", 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.filters, (filter) => {
            return (_openBlock(), _createBlock(_component_SmartStatusFilter, {
              key: `${filter.text}-key`,
              text: filter.text,
              initialValue: filter.initialValue,
              filterCountGet: filter.filterCountGet,
              showNumber: filter.showNumber,
              numberColour: filter.numberColour,
              onFilterToggled: filter.handleToggle
            }, null, 8, ["text", "initialValue", "filterCountGet", "showNumber", "numberColour", "onFilterToggled"]))
          }), 128))
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          class: "filters__menu__apply-button d-flex justify-content-center align-items-center",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleOpen()))
        }, " Apply filters ")
      ])
    ], 2)
  ]))
}